import {
  ActionIcon,
  Anchor,
  Box,
  Button,
  Flex,
  Grid,
  Group,
  Input,
  Title,
  Tooltip,
} from "@mantine/core";
import { IconEdit, IconPlus, IconSearch, IconTrash } from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_ColumnFiltersState,
  MRT_RowSelectionState,
  MRT_SortingState,
  useMantineReactTable,
} from "mantine-react-table";
import { useEffect, useState } from "react";
import { _localization } from "../../../config/location";
import React from "react";
import BreadCrumb from "../../../_base/component/_layout/_breadcrumb";
import Repository from "../../../_base/helper/HttpHelper";
import { useForm } from "@mantine/form";
import { CategorySEO } from "./SEOModal";
import { modals } from "@mantine/modals";
import { CreateViewSeo } from "./CreateViewSeo";
import DeleteViewSeo from "./deleteViewSeo";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { EditViewSeo } from "./EditViewSeo";
import { useLocation } from "react-router-dom";

const CategorySeo = () => {
  const location = useLocation();
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [isError, setIsError] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    []
  );
  const [data, setData] = useState<CategorySEO[]>([]);
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  const [editViewProduct, setEditViewProduct] = useState(false);
  const hacomUrl = process.env.REACT_APP_BASE_WEB_HACOM_URL;

  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";

  const formSeachInput = useForm({
    mode: "uncontrolled",
    initialValues: {
      KeySearch: _searchJson && checkedPinSearch ? _searchJson?.KeySearch : "",
    },
  });

  const columns = React.useMemo<MRT_ColumnDef<CategorySEO>[]>(
    () => [
      // {
      //     header: "STT",
      //     accessorKey: "STT",
      //     Cell: ({ row }) => <>{row?.index + 1}</>,
      //     size: 100,
      // },
      {
        accessorKey: "name",
        header: "Danh mục",
        size: 300,
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      // {
      //   accessorKey: "requestPath",
      //   header: "Link web",
      //   Cell: ({ row }) => {
      //     const item = row.original.requestPath;
      //     return (
      //       <Anchor>
      //         {item && item.trim() !== "" ? (
      //           <a
      //             href={`${hacomUrl}${item}`}
      //             target="_blank"
      //             rel="noopener noreferrer"
      //             style={{ color: "#1976d2", textDecoration: "underline" }}
      //           >
      //             Xem trang
      //           </a>
      //         ) : (
      //           <i style={{ color: "#aaa" }}>Không có link</i>
      //         )}
      //       </Anchor>
      //     );
      //   },
      // },
      {
        accessorKey: "views",
        header: "Lượt xem",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "categoryRelId",
        header: "Số sản phẩm",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      // {
      //     accessorKey: "ordering",
      //     header: "STT hiển thị",
      //     Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      // },
      // {
      //     accessorKey: "status",
      //     header: "Trạng thái",
      //     Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      // },
      // {
      //     accessorKey: "createdAt",
      //     header: "Thuộc tính",
      //     Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      // },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        enableResizing: false,
        size: 100,
        Cell: ({ row }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Tooltip label="Chỉnh sửa">
              <ActionIcon
                variant="light"
                aria-label="Chỉnh sửa"
                color="yellow"
                onClick={async () => {
                  EditItem(
                    row.original.id
                      ? row.original
                      : (row.original as CategorySEO)
                  );
                }}
              >
                <IconEdit size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Xóa">
              <ActionIcon
                variant="light"
                aria-label="Xóa"
                color="red"
                onClick={async () => {
                  await deleteItem([row.original.id]);
                }}
              >
                <IconTrash size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
          </Box>
        ),
      },
    ],
    []
  );

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    const repositoryWeb = new Repository(
      process.env.REACT_APP_Demo_APP_API_URL
    );

    let url = `?Skip=${pagination?.pageIndex * pagination.pageSize}&Take=${
      pagination.pageSize
    }`;
    if (formSeachInput.getValues().KeySearch) {
      url += `&keySearch=${formSeachInput.getValues().KeySearch}`;
    }
    try {
      const response = await repositoryWeb.get(
        `/TblCategoryForSeo/get-list${url}`
      );
      if (response && response.success) {
        let result = response.data;
        setData(result);
        setRowCount(response.totalCount);
      } else {
        setData([]);
        setRowCount(0);
        setIsLoading(false);
      }
    } catch (error) {
      setData([]);
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify({
          ...formSeachInput.getValues(),
          pageSize: pagination.pageSize,
          pageIndex: pagination.pageIndex,
        })
      );
    }
  };

  const deleteItem = async (ids: number[]) => {
    if (ids.length < 1) NotificationExtension.Warn("Bạn chưa chọn dữ liệu !");
    else
      try {
        modals.openConfirmModal({
          title: (
            <>
              <Title order={5}>Xóa dữ liệu này!</Title>
            </>
          ),
          size: "550px",
          children: (
            <DeleteViewSeo idItems={ids} onClose={setDeleteViewStatus} />
          ),
          confirmProps: { display: "none" },
          cancelProps: { display: "none" },
        });
      } catch (error) {
        console.error("Modal error:", error);
        return;
      }
  };

  const CreateItem = async () => {
    try {
      modals.open({
        title: <Title order={5}>Thêm mới danh mục SEO</Title>,
        children: (
          <CreateViewSeo
            onClose={(refresh) => {
              if (refresh) {
                setDeleteViewStatus((prev) => !prev);
              }
            }}
          />
        ),
        centered: true,
        closeOnClickOutside: false,
        closeOnEscape: false,
        withCloseButton: false,
        overlayProps: {
          backgroundOpacity: 0.55,
          blur: 3,
        },
      });
    } catch (error) {
      console.error("Error opening modal:", error);
      NotificationExtension.Fails("Có lỗi khi mở form tạo mới!");
    }
  };

  const EditItem = async (item: CategorySEO) => {
    modals.open({
      size: "lg",
      title: <Title order={5}>Chỉnh sửa danh mục</Title>,
      children: (
        <EditViewSeo
          item={item}
          onClose={(refresh) => {
            if (refresh) {
              setDeleteViewStatus((prev) => !prev);
              fetchData(); // Gọi lại fetchData để refresh
            }
            modals.closeAll();
          }}
        />
      ),
      centered: true,
      closeOnClickOutside: false,
      closeOnEscape: false,
      withCloseButton: false,
      overlayProps: {
        backgroundOpacity: 0.55,
        blur: 3,
      },
    });
  };

  const openModalDelete = () => {
    const selectedIds = Object.keys(rowSelection)
      .filter((key) => rowSelection[key])
      .map((key) => data[parseInt(key)].id);
    if (selectedIds.length === 0) {
      NotificationExtension.Warn("Xin vui lòng chọn dữ liệu để xóa!");
      return;
    } else {
      const ids = selectedIds;
      deleteItem(ids);
    }
  };

  useEffect(() => {
    fetchData();
    setRowSelection({});
  }, [pagination, deleteViewStatus]);

  const table = useMantineReactTable({
    columns,
    data: data || [],
    enableColumnResizing: true,
    enableTopToolbar: false,
    localization: _localization,
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-select"],
        right: ["action"],
      },
      density: "xs",
    },
    enableRowSelection: true,
    onRowSelectionChange: setRowSelection,
    mantineTableContainerProps: {
      style: { maxHeight: height - 100, minHeight: height - 100 },
    },
    enableStickyHeader: true,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,
    onPaginationChange: setPagination,
    state: {
      pagination,
      rowSelection,
    },
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    mantineTableBodyCellProps: () => ({
      style: {
        fontWeight: "550",
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    positionToolbarAlertBanner: "bottom",
  });

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 190 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (150 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  // useEffect(() => {
  //   if (_searchJson) {
  //     setPagination({
  //       pageIndex: _searchJson.pageIndex,
  //       pageSize: _searchJson.pageSize,
  //     });
  //   }
  // }, []);

  return (
    <>
      <Flex
        justify="space-between"
        align="center"
        style={{
          // border: "1px solid #dee2e6",
          padding: "5px 10px",
        }}
      >
        <BreadCrumb />
      </Flex>
      <Grid
        justify="space-between"
        align="center"
        mb={10}
        mt={10}
        style={{
          border: "1px solid #dee2e6",
          padding: "10px 10px",
          overflowX: "hidden",
          overflowY: "hidden",
        }}
      >
        <Grid.Col span="auto">
          <Group gap="sm">
            <Input
              size="sm"
              placeholder="Từ khoá"
              type="text"
              leftSection={<IconSearch color="#15aabf" />}
              {...formSeachInput.getInputProps("KeySearch")}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
            <Button
              type="submit"
              leftSection={<IconSearch size={20} />}
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchData();
              }}
            >
              Tìm kiếm
            </Button>
          </Group>
        </Grid.Col>
        <Grid.Col span="content">
          <Group justify="flex-end">
            <Button
              leftSection={<IconPlus size={14} />}
              onClick={CreateItem}
              color="blue"
              variant="outline"
            >
              Thêm mới
            </Button>
            <Button
              leftSection={<IconTrash size={14} />}
              onClick={openModalDelete}
              color="red"
              variant="outline"
            >
              Xóa (Đã chọn)
            </Button>
          </Group>
        </Grid.Col>
      </Grid>
      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </>
  );
};

export default CategorySeo;
